import { matchPath } from 'react-router'

const paths = Object.freeze({
  AdReplyView: '/meddelanden/svara-annons/:adId',
  Chat: ['/meddelanden', '/meddelanden/:channelId'],
  AccountSettingsRegion: '/konto/plats',
  Transactions: ['/mina-forsaljningar', '/mina-kop'],
  EnvironmentContributionPage: '/mitt-miljobidrag',
  ProfilePage: '/mitt-blocket',
  PublicProfilePage: '/profil/:userId',
  AccountSettings: ['/konto', '/konto/dataskydd'],
  NewsletterOptOut: '/avregistrering-mejl',
  RatingReviews: '/omdome',
  // routes for handling @m10s/account-sdk-browser
  VendAccountSdk: '/vend',
  SchibstedAccountSdk: '/schibsted', // deprecated, please use "/vend"
})

export const isAppRoute = (test) => {
  const isRoute = Object.values(paths).some((path) => {
    /* we sometimes get a query in the url, eg. when going back from 
    schibsted account settings page. */
    const testPath = test || ''
    const pathWithoutQuery = testPath.split('?')[0]

    return matchPath(pathWithoutQuery, {
      path,
      exact: path === '/',
    })
  })
  return isRoute
}
